/* eslint-disable react/jsx-props-no-spreading */
import { useFormikContext } from "formik";

import Input from "components/lib/Shared/Input";

// Identification Details for Minor Guardian
const IdentificationDetailsFormGuardian = ({ field }) => {
  const { setFieldValue } = useFormikContext();
  const handleChange = (e) => {
    setFieldValue(field.name, {
      ...field.value,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <h3 className="my-2 text-lg font-medium leading-6 text-gray-900">
        Guardian Information
      </h3>
      <div className="grid grid-cols-6 gap-6">
        <div className="col-span-6 sm:col-span-2">
          <Input
            label="Full Name"
            name="guardianFullName"
            placeholder="Enter guardian name"
            value={field.value?.guardianFullName ?? ""}
            errorPath="identificationDetails.guardianFullName"
            onBlur={field.onBlur}
            onChange={handleChange}
            disabled={false}
          />
        </div>
        <div className="col-span-6 sm:col-span-2">
          <Input
            label="Relationship"
            name="guardianRelationship"
            placeholder="Enter relationship"
            value={field.value?.guardianRelationship ?? ""}
            errorPath="identificationDetails.guardianRelationship"
            onBlur={field.onBlur}
            onChange={handleChange}
            disabled={false}
          />
        </div>
        <div className="col-span-6 sm:col-span-2">
          <Input
            label="Mobile Number"
            name="guardianMobileNumber"
            placeholder="Enter mobile number"
            value={field.value?.guardianMobileNumber ?? ""}
            errorPath="identificationDetails.guardianMobileNumber"
            onBlur={field.onBlur}
            onChange={handleChange}
            disabled={false}
          />
        </div>
        <div className="col-span-6 sm:col-span-2">
          <Input
            label="Email Address"
            name="guardianEmailAddress"
            placeholder="Enter email"
            type="email"
            value={field.value?.guardianEmailAddress ?? ""}
            errorPath="identificationDetails.guardianEmailAddress"
            onBlur={field.onBlur}
            onChange={handleChange}
            disabled={false}
          />
        </div>
      </div>
    </>
  );
};

export default IdentificationDetailsFormGuardian;
